import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';
import queryString from 'query-string';
import ga from 'analytics';

import PluginService from 'services/PluginService.js';
import {fetchMyProfile} from 'actions/user.js';
import {fetchPlugins} from 'actions/plugins.js';
import {getPlugins} from 'reducers/plugins.js';
import Utils from 'utils/Utils.js';

import {initNavbarState} from 'actions/navbar.js';
import SurveyPageSyncDevices from './SurveyPageSyncDevices.js';
import {handleAuthenticationQueryString} from 'modules/plugins/PluginsContainer.js';

class SurveyPageSyncDevicesContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {error:null, busy:false};
        this.onConnect = this.onConnect.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        console.log('SurveyPageSyncDevicesContainer', this.props);
    }

    
    componentWillMount() {
        ga('send', 'pageview', { 'page': '/virtual/survey-page-sync-devices' }); 
    }

    onConnect(plugin) {
        this.props.preserveState();
    }

   
    getChallengeAnswersByKey() {
        return this.props.surveyPage.challenge.challengeAnswers.reduce((m,item)=>{
                                        m[item.key] = item;
                                        return m;
                                    },{});
    }

    onSubmit(event) {
        this.props.onSubmit(event, {challengeId:this.props.surveyPage.challenge.id});
    }

    render() {
        return <SurveyPageSyncDevices 
                         surveyPage={this.props.surveyPage}
                         onSkip={this.props.onSkip}
                         onSubmit={this.onSubmit}
                         error={this.state.error}
                         busy={this.state.busy}
                         onConnect={this.onConnect} />;
    }

}


export default withRouter(translate('surveys')(SurveyPageSyncDevicesContainer));



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageSyncDevicesContainer.js